import styles from './index.module.css';
import CameraSvg from '../../assets/svg/camera';
import StationDialog from './dialog';
import React, { useState } from 'react';

const Camera: React.FC = (): JSX.Element => {
    const [visible, setVisible] = useState<boolean>(false);

    const showDialog = (): void => setVisible(true);
    const hideDialog = (): void => setVisible(false);

    return (    
        <div className={styles.CameraContiner}>
           <CameraSvg onClick={showDialog} />
            <StationDialog 
              visible={visible} 
              onHide={hideDialog} 
            />
        </div>
    );
};

export default Camera;
